import { createI18n } from 'vue-i18n'
import en from './en.json'
import ru from './ru.json'

const messages = {
  en,
  ru
} as const

const isClient = typeof window !== 'undefined'
const initialLocale = isClient ? window.localStorage.getItem('userLocale') ?? 'en' : 'en'

export const i18n = createI18n({
  legacy: false, // для Composition API
  locale: initialLocale, // язык по умолчанию
  fallbackLocale: 'en', // резервный язык
  messages
})

export const availableLocales = Object.keys(messages) as Array<keyof typeof messages>